import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { forwardRef } from "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { AngleRightSmallOutlined as C } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-right-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import MuiBreadcrumbs from "../../../node_modules/@mui/material/Breadcrumbs/Breadcrumbs.es.js";
import { Wrapping } from "../../foundations/wrapping.es.js";
const BREADCRUMBS_MAX_ITEMS = 5;
const StyledBreadcrumbs = styled(MuiBreadcrumbs)({
  maxWidth: "100%",
  ol: {
    flexWrap: Wrapping.noWrap
  },
  "li:last-of-type": {
    overflow: "hidden"
  }
});
const Breadcrumbs = forwardRef(function Breadcrumbs2({
  children,
  maxItems = BREADCRUMBS_MAX_ITEMS,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsx(StyledBreadcrumbs, { ref, color: "primary", maxItems, separator: /* @__PURE__ */ jsx(C, {}), ...rest, children });
});
export {
  Breadcrumbs
};
//# sourceMappingURL=breadcrumbs.es.js.map
